import { SectionName } from 'types/types'

import {
  ActionType,
  AdminMenuUiActions,
  NavbarColor,
  SET_BLOCK_COLLAPSED,
  SET_NAVBAR_COLOR,
  SET_NEED_TO_SAVE_BLOCK,
} from './actions'
import { AdminMenuUiState } from './state'

export function adminMenuUiStateReducer(state: AdminMenuUiState, action: AdminMenuUiActions): AdminMenuUiState {
  switch (action.type) {
    case ActionType.SET_BLOCK_COLLAPSED: {
      const blocks = [...state.collapsedBlocks]
      const blockIndex = blocks.indexOf(action.payload.block)
      if (!~blockIndex) {
        blocks.push(action.payload.block)
      } else {
        blocks.splice(blockIndex, 1)
      }
      return {
        ...state,
        collapsedBlocks: blocks,
      }
    }

    case ActionType.SET_NEED_TO_SAVE_BLOCK: {
      return {
        ...state,
        needToSaveBlock: action.payload.needToSaveBlock,
      }
    }

    case ActionType.SET_NAVBAR_COLOR: {
      return {
        ...state,
        navbarColor: action.payload.navbarColor,
      }
    }

    default:
      return state
  }
}

export const setCollapsed = (block: SectionName): SET_BLOCK_COLLAPSED => ({
  type: ActionType.SET_BLOCK_COLLAPSED,
  payload: {
    block: block,
  },
})

export const setNeedToSaveBlock = (block: SectionName | ''): SET_NEED_TO_SAVE_BLOCK => ({
  type: ActionType.SET_NEED_TO_SAVE_BLOCK,
  payload: {
    needToSaveBlock: block,
  },
})

export const setNavbarColor = (color: NavbarColor): SET_NAVBAR_COLOR => ({
  type: ActionType.SET_NAVBAR_COLOR,
  payload: {
    navbarColor: color,
  },
})
